/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as import0 from './user-filter.component.css.shim.ngstyle';
import * as import1 from '@angular/core';
import * as import2 from '@angular/router';
import * as import3 from '@angular/common';
import * as import4 from '../../../../app/user-management/user-filter/user-filter.component';
const styles_UserFilterComponent:any[] = [import0.styles];
export const RenderType_UserFilterComponent:import1.RendererType2 = import1.ɵcrt({
  encapsulation: 0,
  styles: styles_UserFilterComponent,
  data: {}
}
);
function View_UserFilterComponent_2(l:any):import1.ɵViewDefinition {
  return import1.ɵvid(0,[
    (l()(),import1.ɵeld(0,(null as any),(null as any),8,'li',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),['\n                                    '])),
    (l()(),import1.ɵeld(0,(null as any),(null as any),5,'a',([] as any[]),[
      [
        1,
        'target',
        0
      ]
      ,
      [
        8,
        'href',
        4
      ]

    ]
      ,[[
        (null as any),
        'click'
      ]
    ],(v,en,$event) => {
      var ad:boolean = true;
      if (('click' === en)) {
        const pd_0:any = ((<any>import1.ɵnov(v,3).onClick($event.button,$event.ctrlKey,$event.metaKey)) !== false);
        ad = (pd_0 && ad);
      }
      return ad;
    },(null as any),(null as any))),
    import1.ɵdid(671744,(null as any),0,import2.RouterLinkWithHref,[
      import2.Router,
      import2.ActivatedRoute,
      import3.LocationStrategy
    ]
    ,{
      queryParams: [
        0,
        'queryParams'
      ]
      ,
      routerLink: [
        1,
        'routerLink'
      ]

    }
    ,(null as any)),
    import1.ɵpod(['selectedRole']),
    import1.ɵpad(1),
    (l()(),import1.ɵeld(0,(null as any),(null as any),0,'i',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),[
      '',
      ''
    ]
    )),
    (l()(),import1.ɵted((null as any),['\n                                ']))
  ]
  ,(ck,v) => {
    var co:any = v.component;
    const currVal_2:any = ck(v,4,0,co.makeQueryable(v.context.$implicit));
    const currVal_3:any = ck(v,5,0,'/init');
    ck(v,3,0,currVal_2,currVal_3);
  },(ck,v) => {
    const currVal_0:any = import1.ɵnov(v,3).target;
    const currVal_1:any = import1.ɵnov(v,3).href;
    ck(v,2,0,currVal_0,currVal_1);
    const currVal_4:any = v.context.$implicit;
    ck(v,7,0,currVal_4);
  });
}
function View_UserFilterComponent_1(l:any):import1.ɵViewDefinition {
  return import1.ɵvid(0,[
      (l()(),import1.ɵeld(0,(null as any),(null as any),22,'section',[[
        'id',
        'filters'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),['\n			'])),
    (l()(),import1.ɵeld(0,(null as any),(null as any),1,'section',[
      [
        'class',
        'search-bar'
      ]
      ,
      [
        'style',
        'width: 100%'
      ]

    ]
    ,(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),['\n			'])),
    (l()(),import1.ɵted((null as any),['\n			'])),
    (l()(),import1.ɵeld(0,(null as any),(null as any),16,'section',[
      [
        'class',
        'filters'
      ]
      ,
      [
        'style',
        'width: 10%'
      ]

    ]
    ,(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),['\n                    '])),
    (l()(),import1.ɵeld(0,(null as any),(null as any),13,'ul',[
      [
        'class',
        'dropdown menu custom actions'
      ]
      ,
      [
        'data-dropdown-menu',
        ''
      ]
      ,
      [
        'id',
        'user-roles'
      ]
      ,
      [
        'name',
        'user-roles'
      ]

    ]
    ,(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),['\n                        '])),
    (l()(),import1.ɵeld(0,(null as any),(null as any),10,'li',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),['\n                            '])),
      (l()(),import1.ɵeld(0,(null as any),(null as any),1,'a',[[
        'href',
        'javascript:void(0)'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),['New User'])),
    (l()(),import1.ɵted((null as any),['\n                            '])),
      (l()(),import1.ɵeld(0,(null as any),(null as any),4,'ul',[[
        'class',
        'menu right-side green'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),['\n                                '])),
    (l()(),import1.ɵand(16777216,(null as any),(null as any),1,(null as any),View_UserFilterComponent_2)),
    import1.ɵdid(802816,(null as any),0,import3.NgForOf,[
      import1.ViewContainerRef,
      import1.TemplateRef,
      import1.IterableDiffers
    ]
      ,{ngForOf: [
        0,
        'ngForOf'
      ]
    },(null as any)),
    (l()(),import1.ɵted((null as any),['\n                            '])),
    (l()(),import1.ɵted((null as any),['\n                        '])),
    (l()(),import1.ɵted((null as any),['\n                    '])),
    (l()(),import1.ɵted((null as any),['\n			'])),
    (l()(),import1.ɵted((null as any),['\n']))
  ]
  ,(ck,v) => {
    var co:any = v.component;
    const currVal_0:any = co._selRoles;
    ck(v,17,0,currVal_0);
  },(null as any));
}
export function View_UserFilterComponent_0(l:any):import1.ɵViewDefinition {
  return import1.ɵvid(0,[
    (l()(),import1.ɵand(16777216,(null as any),(null as any),1,(null as any),View_UserFilterComponent_1)),
    import1.ɵdid(16384,(null as any),0,import3.NgIf,[
      import1.ViewContainerRef,
      import1.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import1.ɵted((null as any),['\n']))
  ]
  ,(ck,v) => {
    var co:import4.UserFilterComponent = v.component;
    const currVal_0:any = co.checkUserAdminORBookOfficer();
    ck(v,1,0,currVal_0);
  },(null as any));
}
function View_UserFilterComponent_Host_0(l:any):import1.ɵViewDefinition {
  return import1.ɵvid(0,[
    (l()(),import1.ɵeld(0,(null as any),(null as any),1,'app-user-filter',([] as any[]),(null as any),(null as any),(null as any),View_UserFilterComponent_0,RenderType_UserFilterComponent)),
    import1.ɵdid(114688,(null as any),0,import4.UserFilterComponent,([] as any[]),(null as any),(null as any))
  ]
  ,(ck,v) => {
    ck(v,1,0);
  },(null as any));
}
export const UserFilterComponentNgFactory:import1.ComponentFactory<import4.UserFilterComponent> = import1.ɵccf('app-user-filter',import4.UserFilterComponent,View_UserFilterComponent_Host_0,{},{},([] as any[]));
//# sourceMappingURL=data:application/json;base64,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



// WEBPACK FOOTER //
// ./src/$$_gendir/app/user-management/user-filter/user-filter.component.ngfactory.ts